import { render, staticRenderFns } from "./deviceAccess.vue?vue&type=template&id=c56524f8&scoped=true"
import script from "./deviceAccess.vue?vue&type=script&lang=js"
export * from "./deviceAccess.vue?vue&type=script&lang=js"
import style0 from "./deviceAccess.vue?vue&type=style&index=0&id=c56524f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c56524f8",
  null
  
)

export default component.exports